import React from "react";
import { X, CheckCircle } from "lucide-react";

export interface SuccessNotificationProps {
    show: boolean;
    message: string;
    onClose: () => void;
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({ show, message, onClose }) => {
    if (!show) return null;

    return (
        <div className="fixed top-4 right-4 z-[70] animate-in slide-in-from-top duration-300">
            <div className="bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 flex items-center gap-3 min-w-[300px]">
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <CheckCircle className="w-6 h-6 text-green-600" />
                </div>
                <div className="flex-1">
                    <h4 className="font-semibold text-gray-900 mb-0.5">Success!</h4>
                    <p className="text-sm text-gray-600">{message}</p>
                </div>
                <button
                    onClick={onClose}
                    className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <X size={18} />
                </button>
            </div>
        </div>
    );
};

export default SuccessNotification;
